import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import { Drawer } from '@sainsburys-tech/bolt';
import DrawerHeader from './components/DrawerHeader/DrawerHeader';
import DrawerContent from './components/DrawerContent/DrawerContent';
import DrawerFooter from './components/DrawerFooter/DrawerFooter';
import Error from './components/Error/Error';
import Loader from './components/Loader/Loader';
import { findCurrentVariant, fetchProductData, findVariantsFromProduct } from './helpers';
import { trackCloseDrawerEvent, trackOpenDrawerEvent } from './helpers/trackingUtils';
import reducer from './reducers';
import { UPDATE_PRODUCT } from './types';

var AttributeSelectorDrawer = function AttributeSelectorDrawer(props) {
  var showDrawer = props.showDrawer,
      onDrawerClose = props.onDrawerClose,
      attributeType = props.attributeType,
      _props$productVariant = props.productVariants,
      productVariants = _props$productVariant === void 0 ? [] : _props$productVariant,
      partNumber = props.partNumber,
      doFetch = props.doFetch,
      _props$pageType = props.pageType,
      pageType = _props$pageType === void 0 ? '' : _props$pageType;
  if (!attributeType || !partNumber) return null;
  var currentVariant = findCurrentVariant(productVariants, partNumber); // Set the initial state of the drawer

  var initialState = {
    attributeType: attributeType.toLowerCase(),
    selectedProduct: currentVariant
  };

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var _useState = useState(productVariants),
      _useState2 = _slicedToArray(_useState, 2),
      productVariantsData = _useState2[0],
      setProductVariantsData = _useState2[1];

  var _useState3 = useState(currentVariant),
      _useState4 = _slicedToArray(_useState3, 2),
      currentVariantData = _useState4[0],
      setCurrentVariantData = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isLoading = _useState6[0],
      setIsLoading = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isError = _useState8[0],
      setIsError = _useState8[1];

  var showLoader = doFetch && isLoading && !isError;
  var showError = doFetch && !isLoading && isError; // Handle the closing of the drawer

  var _onClose = function onClose() {
    // Pass the selected product back to the parent component when the drawer is closed
    onDrawerClose(state.selectedProduct);
  };

  var trackOnClose = function trackOnClose(e) {
    // Check if the Button or SVG element was clicked
    var closeIcon = e.target.tagName === 'BUTTON' || e.target.tagName === 'svg';
    var overlay = e.target.tagName === 'DIV' && e.target.getAttribute('data-test') === 'component-drawer-overlay';

    if (closeIcon) {
      trackCloseDrawerEvent(pageType, attributeType, 'icon');
    } else if (overlay) {
      trackCloseDrawerEvent(pageType, attributeType, 'overlay');
    }
  };

  var getProductVariants = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var productData, variantsFromProduct, currentVariantFromProduct;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setIsLoading(true);
              _context.next = 4;
              return fetchProductData(partNumber);

            case 4:
              productData = _context.sent;
              variantsFromProduct = findVariantsFromProduct(productData);

              if (variantsFromProduct) {
                currentVariantFromProduct = findCurrentVariant(variantsFromProduct, partNumber);
                setProductVariantsData(variantsFromProduct);
                setCurrentVariantData(currentVariantFromProduct);
                dispatch({
                  type: UPDATE_PRODUCT,
                  payload: currentVariantFromProduct
                });
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              setIsError(true);

            case 12:
              _context.prev = 12;
              setIsLoading(false);
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9, 12, 15]]);
    }));

    return function getProductVariants() {
      return _ref.apply(this, arguments);
    };
  }();

  var renderContent = function renderContent() {
    if (showError) {
      return /*#__PURE__*/React.createElement(Error, null);
    }

    if (showLoader) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } // Temp removal of 'Leg colour' attribute as it is duplicate of 'Feet colour' attribute


    var variants = productVariantsData.map(function (variant) {
      var _variant$attributes;

      return _objectSpread(_objectSpread({}, variant), {}, {
        attributes: (variant === null || variant === void 0 ? void 0 : (_variant$attributes = variant.attributes) === null || _variant$attributes === void 0 ? void 0 : _variant$attributes.filter(function (attr) {
          return attr.type !== 'Leg colour';
        })) || []
      });
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerContent, {
      attributeType: state.attributeType,
      selectedProduct: state.selectedProduct,
      productVariants: variants,
      currentVariant: currentVariantData,
      dispatch: dispatch,
      pageType: pageType
    }), /*#__PURE__*/React.createElement(DrawerFooter, {
      attributeType: state.attributeType,
      selectedProduct: state.selectedProduct,
      onClose: _onClose
    }));
  };

  return /*#__PURE__*/React.createElement(Drawer, {
    show: showDrawer,
    size: "full",
    onClose: function onClose(e) {
      trackOnClose(e);

      _onClose();
    },
    onOpen: function onOpen() {
      trackOpenDrawerEvent(pageType, attributeType);
      if (doFetch) getProductVariants();
    }
  }, /*#__PURE__*/React.createElement(DrawerHeader, {
    attributeType: state.attributeType
  }), renderContent());
};

AttributeSelectorDrawer.propTypes = {
  showDrawer: PropTypes.bool.isRequired,
  onDrawerClose: PropTypes.func.isRequired,
  attributeType: PropTypes.string.isRequired,
  productVariants: PropTypes.array.isRequired,
  partNumber: PropTypes.string.isRequired
};
export default AttributeSelectorDrawer;